import { render, staticRenderFns } from "./Breakdowns.vue?vue&type=template&id=e9c034fc&scoped=true&"
import script from "./Breakdowns.vue?vue&type=script&lang=js&"
export * from "./Breakdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c034fc",
  null
  
)

export default component.exports